import { useState } from "react";
import Block from '../new/block1'; // Supposons que Block est ton composant de saisie

const EditableBlockList = ({ onDiagnosisChange }) => {
  const [doctorDiagnosis, setDoctorDiagnosis] = useState("");
  const [aiDiagnosis, setAiDiagnosis] = useState("");

  const handleDoctorDiagnosisChange = (newDiagnosis) => {
    setDoctorDiagnosis(newDiagnosis);
    onDiagnosisChange(newDiagnosis, 'doctorDiagnosis'); // Envoie au parent
  };

  const handleAiDiagnosisChange = (newDiagnosis) => {
    setAiDiagnosis(newDiagnosis);
    onDiagnosisChange(newDiagnosis, 'aiDiagnosis'); // Envoie au parent
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold text-center"
          style={{ background: '#0056B32B', borderRadius: '15px' }}
          onClick={toggleDropdown}
        >
          Diagnosis
        </p>
        <i
          className="bi bi-caret-down-fill pos1"
          style={{ color: '#0056B3' }}
        ></i>
      </div>

      {isOpen && (
        <div style={{ margin: '0px 40px' }}>
          <div className="mb-4 mt-3 p-3" style={{ border: '1px dashed #0056B3', borderRadius: '10px' }}>
            <p className="p-2 text-center fw-bold" style={{ background: '#0056B317' }}>AI’s generated Diagnosis</p>
            <p>
              <strong style={{ textDecoration: 'underline' }}>Suspected Urinary Tract Infection (UTI)</strong> <br />
              Based on the severity and duration of the symptoms, it is likely acute bronchitis rather than chronic bronchitis. However, if symptoms persist beyond 3 weeks, further investigations may be necessary to rule out other conditions like asthma or chronic obstructive pulmonary disease (COPD). <br /> <br />
              After conducting a thorough clinical examination and reviewing the patient's medical history, it has been determined that the patient is experiencing symptoms consistent with bronchitis.
            </p>
          </div>

          <div>
            <Block
              initialLabel="Doctor’s diagnosis"
              initialContent={doctorDiagnosis}
              onContentChange={handleDoctorDiagnosisChange} // Mise à jour du diagnostic du médecin
            />
          </div>

          <div>
            <Block
              initialLabel="AI’s Diagnosis"
              initialContent={aiDiagnosis}
              onContentChange={handleAiDiagnosisChange} // Mise à jour du diagnostic de l'IA
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
